import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import GoogleMapComponent from "../GoogleMapComponent";
import AlertMessage from "../include/AlertMessage";
import { useAuth } from "../../context/AuthContext";
import { storage, ID, Permission, Role } from "../../appwrite/config";
var _ = require('lodash');


function EditEvent() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const { role, user } = useAuth();
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({ imageID: [], userid: '', name: '', price: '', expiryDate: '', eventDate: '', latitude: '', longitude: '', description: '', isActive: false });
    const [errors, setErrors] = useState({});
    const [images, setImages] = useState([]);
    const [deletedImageIds, setDeletedImageIds] = useState([]);
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const [allUsers, setAllUsers] = useState([]);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.description) newErrors.description = "Description is required.";
        if (!formData.latitude) newErrors.latitude = "Latitude is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude is required.";
        if (!formData.expiryDate) newErrors.expiryDate = "Expire Date is required.";
        if (!formData.price) newErrors.price = "Price is required.";
        if (!formData.eventDate) newErrors.eventDate = "Event Date is required.";
        return newErrors;
    };


    // Define an async function inside useEffect
    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetcheventdetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;

            // 🔥 UPDATED: structured images
            let imgs = [];
            if (Array.isArray(resdata.imageID)) {
                imgs = resdata.imageID.map(imgId => ({
                    url: storage.getFilePreview(process.env.REACT_APP_BUCKET_ID, imgId).toString(),
                    id: imgId,
                    isNew: false
                }));
            }
            setImages(imgs);

            //convert event expire date to YYYY-MM-DD
            const myDate = new Date(resdata.expiryDate);
            const expdate = myDate.toISOString().split('T')[0]; // '2025-05-23'

            const myEventDate = new Date(resdata.eventDate);
            const eventdate = myEventDate.toISOString().split('T')[0]; // '2025-05-23'

            const customdata = {
                userid: resdata.user || '',
                imageID: resdata.imageID || [],
                name: resdata.name,
                description: resdata.description,
                isActive: resdata.isActive,
                latitude: resdata.latitude,
                longitude: resdata.longitude,
                expiryDate: expdate,
                price: resdata.price,
                eventDate: eventdate

            }
            setFormData(customdata); // Set data to state
            //setIsToggled(resdata.isActive);
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        document.documentElement.className = "";

        if (role === "event" && user?.$id) {
            setFormData(prev => ({
                ...prev,
                userid: user.$id
            }));
        }

        fetchAllUsers();

        fetchData();
    }, [id]);


    //Get all users having the event role.
    const fetchAllUsers = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                params: {
                    roleType: "event"
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }

            });

            const data = await response.data.data;

            if (Array.isArray(data) && data.length > 0) {
                setAllUsers(data);
            } else {
                setAllUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : e.target.value });
    };

    const handleFileChange = async (e) => {
        e.preventDefault();

        const selectedFiles = Array.from(e.target.files);
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // ✅ 2MB

        let validFiles = [];
        let invalidFiles = [];

        selectedFiles.forEach(file => {

            // ❌ Type validation
            if (!allowedTypes.includes(file.type)) {
                invalidFiles.push(file.name + " (invalid type)");
                return;
            }

            // ❌ Size validation
            if (file.size > maxSize) {
                invalidFiles.push(file.name + " (too large)");
                return;
            }

            // ✅ Valid file
            validFiles.push(file);
        });

        // ❌ Show error if any invalid files
        if (invalidFiles.length > 0) {
            setAlert({
                type: "error",
                message: `Some files are invalid: ${invalidFiles.join(", ")}`
            });
        }

        // ✅ Add only valid images
        const newImages = validFiles.map(file => ({
            url: URL.createObjectURL(file),
            file: file,
            isNew: true
        }));

        setImages(prev => [...prev, ...newImages]);
    };

    // 🆕 DELETE IMAGE (both preview + existing imageID)
    const handleRemoveImage = async (index) => {
        const imageToDelete = images[index];

        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        try {
            // delete from Appwrite if old
            if (!imageToDelete.isNew && imageToDelete.id) {
                setDeletedImageIds(prev => [...prev, imageToDelete.id]);
            }

            const updatedImages = images.filter((_, i) => i !== index);
            setImages(updatedImages);

            // update formData image IDs
            const remainingIds = updatedImages
                .filter(img => !img.isNew)
                .map(img => img.id);

            setFormData(prev => ({
                ...prev,
                imageID: remainingIds
            }));


        } catch {
            setAlert({ type: "error", message: "Failed to delete image" });
        }
    };

    const handleEventEdit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {
                for (let id of deletedImageIds) {
                    await storage.deleteFile(process.env.REACT_APP_BUCKET_ID, id);
                }

                const uploadPromises = images
                    .filter(img => img.isNew && img.file)
                    .map(img =>
                        storage.createFile(
                            process.env.REACT_APP_BUCKET_ID,
                            ID.unique(),
                            img.file,
                            [
                                Permission.read(Role.any()),
                                Permission.write(Role.any()) // 🔥 FIX (important)
                            ]
                        )
                    );

                const uploadedFiles = await Promise.all(uploadPromises);
                const uploadedIds = uploadedFiles.map(file => file.$id);

                // 🔥 existing images
                const existingIds = images
                    .filter(img => !img.isNew)
                    .map(img => img.id);

                const finalImageIds = [...existingIds, ...uploadedIds];

                //API URL
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editevent/${id}`, {
                    userid: formData.userid,
                    imageID: finalImageIds,
                    "name": formData.name,
                    "description": formData.description,
                    "latitude": formData.latitude,
                    "longitude": formData.longitude,
                    "expiryDate": formData.expiryDate,
                    "price": formData.price,
                    "eventDate": formData.eventDate,
                    "isActive": formData.isActive
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Event updated successfully." });                                     
                    setTimeout(() => redirectHistory(`/events?page=${page}`), 2500);  // redirect to listing page                    
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit event. Please try again.");
                setAlert({ type: "error", message: apierror });
            } finally {
                setTimeout(() => setLoading(false), 1000);
            }
        }
    }


    const handleLocationSelect = ({ lat, lng }) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/Events" className='btn btn-primary'>Events</Link></li>
                        <li>Edit</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit Event
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEventEdit}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        {["admin"].includes(role) ? (
                                            <div className="field">
                                                <label className="label">User</label>

                                                <div className="control">
                                                    <div className="select">
                                                        <select id="userid" name="userid" value={formData.userid || ''} onChange={handleChange} >
                                                            <option value="">---Select---</option>
                                                            {allUsers.map((user) => (
                                                                <option key={user.$id} value={user.$id}>
                                                                    {user.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        ) : (
                                            <input type="hidden" name="userid" id="userid" value={formData.userid} />
                                        )}
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="name" id="name" type="text" placeholder="Name" value={formData.name} onChange={handleChange} />
                                            </div>
                                            {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="price">Price <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="price" id="price" type="text" placeholder="Price" value={formData.price} onChange={handleChange} />
                                            </div>
                                            {errors.price && <p className="help" style={{ color: 'red' }}>{errors.price}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="latitude">Latitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="latitude" type="text" placeholder="Latitude" value={formData.latitude} onChange={handleChange} />
                                            </div>
                                            {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                        </div>

                                        <div className="field">
                                            <label className="label" htmlFor="longitude">Longitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly id="longitude" type="text" placeholder="Longitude" value={formData.longitude} onChange={handleChange} />
                                            </div>
                                            {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label className="label" htmlFor="description">Description <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <textarea className="textarea" name="description" id="description" placeholder="Description" value={formData.description} onChange={handleChange} ></textarea>
                                        </div>
                                        {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="expiryDate">Expire Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="expiryDate" id="expiryDate" type="date" placeholder="Expire Date" value={formData.expiryDate} onChange={handleChange} />
                                            </div>
                                            {errors.expiryDate && <p className="help" style={{ color: 'red' }}>{errors.expiryDate}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="eventDate">Event Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="eventDate" id="eventDate" type="date" placeholder="Event Date" value={formData.eventDate} onChange={handleChange} />
                                            </div>
                                            {errors.eventDate && <p className="help" style={{ color: 'red' }}>{errors.eventDate}</p>}
                                        </div>
                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">&nbsp;</label>
                                            <div className="control">
                                                <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={handleChange} />
                                                    <span className="check"></span>
                                                    <span className="control-label">Active</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <label className="label">Image</label>
                                            <div className="control">
                                                <input className="input" id="simage" accept="image/*" type="file" multiple onChange={handleFileChange} />
                                            </div>
                                            {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                        </div>
                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">
                                        {/* 🆕 IMAGE PREVIEW CARD SECTION */}
                                        {images.length > 0 && (
                                            <div className="card">
                                                <header className="card-header">
                                                    <p className="card-header-title">
                                                        Image Preview
                                                    </p>
                                                </header>

                                                <div className="card-content">
                                                    <div style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "15px"
                                                    }}>
                                                        {images.map((img, i) => (
                                                            <div key={i} style={{
                                                                position: "relative",
                                                                width: "120px",
                                                                height: "100px"
                                                            }}>
                                                                {/* 🆕 DELETE BUTTON */}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(i)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-8px",
                                                                        right: "-8px",
                                                                        background: "red",
                                                                        color: "#fff",
                                                                        border: "none",
                                                                        borderRadius: "50%",
                                                                        width: "22px",
                                                                        height: "22px",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px",
                                                                        zIndex: 10
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>

                                                                {/* IMAGE */}
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #ddd"
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="field">
                                        <div className="control">
                                            {/* <GoogleMapComponent onLocationSelect={handleLocationSelect} /> */}

                                            <GoogleMapComponent
                                                onLocationSelect={handleLocationSelect}
                                                defaultPosition={{ lat: Number(formData.latitude), lng: Number(formData.longitude) }} // edit lat/lng
                                            />
                                        </div>
                                    </div>



                                    <div class="flex justify-center items-center">
                                        <div class="field grouped">
                                            <div class="control">
                                                <button type="submit" class="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditEvent;
